import { calculationLimits, designVehicles } from "store/calculation.config";
import { calculateWideningFromHorizontalData } from "utilities/geometricRoadutilities/calculateWideningFromHorizontalData";

export const calculateWidening = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_LANE_WIDTH_TOO_LOW: false,
        TOOLS_LANE_WIDTH_TOO_HIGH: false,
    };

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            horizontalGeometry: {value: null, valid: null, severity: null},
            designVehicle: {value: null, valid: null, severity: null},
            speedlimit: {value: null, valid: null, severity: null},
            laneWidth: {value: null, valid: null, severity: null},
        },
        derived:
        {

        },
        output:
        {
            wideningData: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    calulcateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return calculationContext;
}

const validateValues = (ctx, errors) => {
    // #region design vehicle
    if(ctx.normalizedInput.designVehicle.trim() !== '')
    {
        let designVehicleObject = designVehicles[ctx.normalizedInput.designVehicle];
        if(designVehicleObject) ctx.input.designVehicle = {value: designVehicleObject, valid: true, severity: null};
        else ctx.input.designVehicle = {value: null, valid: false, severity: 'error'};
    }
    // #endregion

    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region lane width
    if(ctx.normalizedInput.laneWidth.trim() !== '')
    {
        const laneWidth = Number(ctx.normalizedInput.laneWidth.trim());
        if(laneWidth < 1)
        {
            ctx.input.laneWidth = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LANE_WIDTH_TOO_LOW = true;
        }
        else if(laneWidth > 10)
        {
            ctx.input.laneWidth = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LANE_WIDTH_TOO_HIGH = true;
        }
        else
        {
            ctx.input.laneWidth = {value: laneWidth, valid: true, severity: null};
        }
    }
    // #endregion

    // #region horizontal geometry
    if(ctx.normalizedInput.horizontalGeometry)
    {
        if(Array.isArray(ctx.normalizedInput.horizontalGeometry) && ctx.normalizedInput.horizontalGeometry.length !== 0)
        {
            ctx.input.horizontalGeometry = {
                value: ctx.normalizedInput.horizontalGeometry,
                valid: true,
                severity: false,
            }
        }
    }
    // #endregion
}

const calulcateOutput = (ctx, errors) => {
    if(ctx.input.speedlimit.valid && ctx.input.designVehicle.valid && ctx.input.laneWidth.valid && ctx.input.horizontalGeometry.valid)
    {
        const wideningData = calculateWideningFromHorizontalData(ctx.input.horizontalGeometry.value, ctx.input.laneWidth.value, ctx.input.speedlimit.value, ctx.input.designVehicle.value);
        if(wideningData && Array.isArray(wideningData) && wideningData.length !== 0)
        {
            ctx.output.wideningData = {
                value: wideningData,
                valid: true,
                severity: null
            }
        }
    }
}